import { regexOnlyNumber } from 'shell/constants/regex';
import * as yup from 'yup';

export const civilUnionSchemaObject = {
  surname: yup.string().required('Campo obbligatorio'),
  name: yup.string().required('Campo obbligatorio'),
  surname2: yup.string().required('Campo obbligatorio'),
  name2: yup.string().required('Campo obbligatorio'),
  gender: yup.string().required('Campo obbligatorio'),
  gender2: yup.string().required('Campo obbligatorio'),
  civilUnionDate: yup.date().nullable().typeError('Data non valida').required('Campo obbligatorio'),
  civilUnionMunicipality: yup.string().required('Campo obbligatorio'),
  yearDateDeclarant1: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
  yearsDeclarant1: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
  yearDateDeclarant2: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
  yearsDeclarant2: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
};

const createSchema = yup.object().shape(civilUnionSchemaObject);

export default createSchema;
